<template>
  <div class="header">
    <!-- 折叠按钮 -->
    <div class="collapse-btn" @click="collapseChage">
      <i class="el-icon-menu"></i>
    </div>
    <div class="logo">会展数据管理系统</div>
    <div class="header-right">
      <div class="header-user-con">
        <!-- 消息中心 -->
        <div class="btn-bell" v-if="!groupUser">
          <el-select v-model="projectId" placeholder="当前项目" v-if="show">
            <el-option
                :key="index"
                v-for="(item, index) in product"
                :label="item.name"
                :value="item.projectId"
                v-if="item.enabled===1"
            >
              <div @click="getChangeProduct(item)">{{ item.name }}</div>
            </el-option>
          </el-select>
          <el-select v-model="projectId" placeholder="当前项目"
                     v-else>
            <el-option
                :key="index"
                v-for="(item, index) in product"
                :label="item.name"
                :value="item.projectId"
            >
              <div @click="getChangeProduct(item)">{{ item.name }}</div>
            </el-option>
          </el-select>
          <span style="height:50px;display: inline-block;float: right" v-html="projectId"></span>
        </div>
        <!-- 全屏显示
        <div class="btn-fullscreen" @click="handleFullScreen">
          <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
            <i class="el-icon-rank"></i>
          </el-tooltip>
        </div> -->
        <!-- 用户头像
       <div class="user-avator">
          <img src="../../assets/img/img.jpg" />
        </div>-->
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ name }}
            <span>[{{ roles }}]</span>&nbsp;<b v-if="groupUser">{{ project }}</b>
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="putpassword" v-if="!groupUser">
              <el-button type="text" @click="putPassword">修改密码</el-button>
            </el-dropdown-item>
            <el-dropdown-item command="loginout">
              <el-button type="text" @click="loginOut">注销登录</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 修改密码弹出框 -->
    <el-dialog title="修改密码" :visible.sync="editVisible" width="35%">
      <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-form-item label="旧密码" prop="password">
          <el-input
              type="password"
              v-model="ruleForm.password"
              autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
              type="password"
              v-model="ruleForm.newPassword"
              autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
          >提交
          </el-button
          >
          <el-button @click="editVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import bus from "../common/bus";

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      console.log(rule);
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码只能6-16个字母、数字、下划线"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      show: '业务员，夜值人员，公安人员'.indexOf(localStorage.getItem('roles').toString()) > -1,
      groupUser: '团组'.indexOf(localStorage.getItem('roles').toString()) > -1,
      ruleForm: {
        password: "",
        id: localStorage.getItem("accountId"),
        newPassword: "",
        checkPass: "",
        phone: localStorage.getItem("ms_username"),
      },
      rules: {
        password: [
          {required: true, validator: validatePass, trigger: "blur"},
        ],
        newPassword: [
          {required: true, validator: validatePass, trigger: "blur"},
        ],
        checkPass: [
          {required: true, validator: validatePass2, trigger: "blur"},
        ],
      },
      collapse: false,
      fullscreen: false,
      name: localStorage.getItem("name"),
      editVisible: false,
      projectId: localStorage.getItem("project_Id"),
      project: localStorage.getItem("project"),
      roles: localStorage.getItem("roles"),
      accountId: localStorage.getItem("accountId"),
      username: localStorage.getItem("ms_username"),
      product: [],
    };
  },
  created: function () {
    this.getProject();
  },
  methods: {
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if (command == "loginout") {
        localStorage.removeItem("ms_username");
        this.$router.push("/login");
      }
    },
    // 侧边栏折叠
    collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit("collapse", this.collapse);
    },
    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    putPassword() {
      this.editVisible = true;
    },
    // 注销登录
    loginOut() {
      localStorage.removeItem("ms_username");
      localStorage.removeItem("project_Id");
      localStorage.removeItem("project");
      location.href = "/login";
    },
    // 修改密码
    submitForm(formData) {
      var data = {
        id: this.ruleForm.id,
        password: this.ruleForm.password,
        newPassword: this.ruleForm.newPassword,
        checkPass: this.ruleForm.checkPass,
      };
      this.$refs[formData].validate((valid) => {
        if (valid) {
          this.$axios.post("/Account/Password", data).then((res) => {
            if (res.data.hasError == true) {
              this.$message.error(res.data.message);
            } else {
              this.$refs["ruleForm"].resetFields();
              this.$message({
                message: "新密码修改成功",
                type: "success",
              });
              this.editVisible = false;
            }
          });
        }
      });
    },
    getChangeProduct(row) {
      localStorage.setItem("project_Id", row.projectId);
      this.$axios
          .get(
              `/Account/Project/${this.ruleForm.id}/${row.name}/${row.projectId}`
          )
          .then((res) => {
            if (res.data.hasError == true) {
              this.$message.error(res.data.message);
            } else {
              this.$message({
                message: "更改当前项目成功",
                type: "success",
              });
              setTimeout(() => {
                location.reload();
              }, 1200);
            }
          });
    },
    getProjectRole(dd) {
      dd.forEach((item, index) => {
        if (localStorage.getItem("project_Id") == item.projectId) {
          localStorage.setItem("startDate", item.startDate);
        }
      });
      this.$axios
          .get(`/AccountProjectRole/Project/${this.accountId}`)
          .then((res) => {
            if (res.data.hasError == false) {
              if (res.data.data && res.data.data.length > 0) {
                let ids = new Array();
                for (let i = 0; i < res.data.data.length; i++) {
                  ids.push(res.data.data[i].projectId);
                }
                let bb = new Array();

                dd.forEach((item, index) => {
                  if (ids.indexOf(item.projectId) < 0) {
                    if (item.projectId === this.projectId) {
                      bb.push(item);
                    }
                  } else {
                    bb.push(item);
                  }
                });
                this.product = [...bb];
                localStorage.setItem("global", false);
              } else {
                if (localStorage.getItem("roles") !== "超级管理员") {
                  let bb = new Array();

                  dd.forEach((item, index) => {
                    if (item.projectId === this.projectId) {
                      bb.push(item);
                    }
                  });
                  this.product = [...bb];
                  localStorage.setItem("global", false);
                } else {
                  this.product = [...dd];
                  localStorage.setItem("global", true);
                }
              }
            }
          });
    },
    getProject() {
      if (localStorage.getItem("roles") === "公安人员" ||
          localStorage.getItem("roles") === "夜值人员") {
        if (window.location.href.indexOf("/gb") > 0) {
          this.$axios.get(`/Project/ProjectType/1`).then((res) => {
            if (res.data.hasError == false) {
              this.product = [...res.data.data];
              localStorage.setItem("global", false);
            }
          });
        } else {
          this.$axios.get(`/Project/`).then((res) => {
            if (res.data.hasError == false) {
              localStorage.setItem("global", false);
              this.getProjectRole(res.data.data);
            }
          });
        }
      } else {
        if (localStorage.getItem("roles") === "接待人员" ||
            localStorage.getItem("roles") === "公安审核人员") {
          this.$axios.get(`/Project/`).then((res) => {
            if (res.data.hasError == false) {
              localStorage.setItem("global", false);
              this.getProjectRole(res.data.data);
            }
          });
        } else {
          this.$axios.get(`/Project/`).then((res) => {
            if (res.data.hasError == false) {
              this.getProjectRole(res.data.data);
            }
          });
        }
      }
    },
  },
  mounted() {
    if (document.body.clientWidth < 1500) {
      this.collapseChage();
    }
  },
};
</script>
<style scoped>
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 70px;
  font-size: 22px;
  color: #fff;
}

.collapse-btn {
  float: left;
  padding: 0 21px;
  cursor: pointer;
  line-height: 70px;
}

.header .logo {
  float: left;
  width: 250px;
  line-height: 70px;
}

.header-right {
  float: right;
  padding-right: 50px;
}

.header-user-con {
  display: flex;
  height: 70px;
  align-items: center;
}

.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}

.btn-bell {
  width: 500px;
  font-size: 15px;
  vertical-align: bottom;
  line-height: 50px;
}

.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}

.btn-bell .el-icon-bell {
  color: #fff;
}

.user-name {
  margin-left: 10px;
}

.user-avator {
  margin-left: 20px;
}

.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}

.el-dropdown-menu__item {
  text-align: center;
}

.el-select {
  width: auto;
}
</style>